module.exports = __webpack_public_path__ + "static/img/emotions1_13.bf89e80.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/emotions/images/emotions1_13.png
// module id = sA1T
// module chunks = 0